/* Only the cat cart add-on cards use this one-time action. */
(() => {
  'use strict';
  if (window.ocCatUpsellsOnce) return;
  window.ocCatUpsellsOnce = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-oc-cat-once-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const card = button.closest('.oc-cat-once__card');
    const root = button.closest('.oc-cat-once');
    const copy = JSON.parse(root.querySelector('[data-oc-cat-once-copy]').textContent);
    const status = card.querySelector('[role=alert]');
    const recover = card.querySelector('.oc-cat-once__recover');
    const label = button.querySelector('[data-oc-cat-once-label]');
    const original = label.innerHTML;
    const id = Number(button.dataset.variantId);
    if (!Number.isSafeInteger(id) || id < 1) return;
    const drawer = document.querySelector('cart-drawer');
    const shopRoot = window.Shopify?.routes?.root || '/';
    const sections = drawer?.getSectionsToRender?.().map(section => section.id) || ['cart-drawer','cart-icon-bubble'];
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    label.textContent = copy.adding;
    status.hidden = true;
    recover.hidden = true;
    let added = false;
    try {
      drawer?.setActiveElement?.(button);
      const response = await fetch(shopRoot + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          items:[{id,quantity:1,properties:{_oc_upsell:'cat-cart-one-time'}}],
          sections,sections_url:location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || copy.error);
      added = true;
      if (data.items?.some(item => item.selling_plan_allocation)) throw new Error(copy.addedError);
      label.textContent = copy.added;
      if (drawer?.renderContents && data.sections?.['cart-drawer']) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        location.assign(shopRoot + 'cart');
      }
    } catch (error) {
      status.textContent = added ? copy.addedError : (error.message || copy.error);
      status.hidden = false;
      if (added) {
        recover.hidden = false;
        label.textContent = copy.added;
      } else {
        button.disabled = false;
        label.innerHTML = original;
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();

